export const SHOPPING_BASKET_UPDATING_END = "SHOPPING_BASKET_UPDATING_END"
export const SHOPPING_BASKET_UPDATING_START = "SHOPPING_BASKET_UPDATING_START"
